<template>
	<div class="upsell-modal" v-if="modalShown">
		<div class="togglers-modal-wrapper">
			<button class="btn btn-plain btn-close" @click="closeModal">
				<span v-text="$__('cart.close')"></span>
				<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg?v1.3#icon-close"></use></svg>
			</button>
			<div class="options-wrapper">
				<h5 v-text="$__('checkout.upsell.title')" />
				<p v-text="$__('checkout.upsell.lead')" />
				<div class="product-single--info">
					<span class="tags">
						<span v-if="upsell.product.is_new" class="tag" v-text="$__('page.shop.tag_new')"></span>
						<span
							v-for="tag in (upsell.product.tags && upsell.product.tags.split(',') || [])"
							class="tag"
							v-text="tag"
						></span>
						<span
							v-if="parseFloat(upsell.product.price_discount)"
							class="tag tag-discount"
						>-{{ parseFloat(upsell.product.price_discount).toFixed(0) }}%</span>
					</span>
					<h1 id="h4 product_title_id" class="h5">{{ upsell.product.title }}</h1>
					<div class="row">
						<div class="col-md-4">
							<img :src="`/storage/${upsell.product.picture}`" :alt="upsell.product.title" class="img-fluid" />
						</div>
						<div class="col-md-8">
							<div class="page-product--single-product">

								<lupit-addtocart
									:lengths="upsell.lengths"
									:recommended="null"
									:extension="upsell.extension"
									:extensions="upsell.extensions"
									:product="upsell.product.id"
									:stock="!upsell.product.is_onstock ? 0 : 1"
									:title="upsell.product.title"
									:lead="upsell.product.lead"
									:price="upsell.product.locale_price && upsell.product.locale_price.price || upsell.product.price"
									:price_regular="parseFloat(upsell.product.locale_price && upsell.product.locale_price.price || upsell.product.price_regular)"
									:discount="parseFloat(upsell.product.price_discount)"
									:discount_price="parseFloat(upsell.product.discount_price)"
									:variants="upsell.product.active_variants || []"
									:buy_type="upsell.product.is_quote_only"
									:product_thumb="upsell.product.thumbnail"
									:variant_extensions="upsell.variant_extensions"
									:region_id="upsell.region.id"
									:item="upsell.product"
									:affiliate="upsell.affiliate"
									:show-bar="false"
									@product-added="closeModal"
								></lupit-addtocart>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Upsell",
	props: {
		upsell: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			modalShown: false,
			product_id: null,
			length: null,
			buy_type: 0
		}
	},
	methods: {
		closeModal() {
			this.modalShown = false;
		},
	},
	mounted() {
		if (window.cookies.get('showUpsell') === undefined) {
			this.modalShown = true
			window.cookies.set('showUpsell', true);
		}
	}
}
</script>
